import { render, staticRenderFns } from "./DemoTimePickerFormat.vue?vue&type=template&id=a08d408c&"
import script from "./DemoTimePickerFormat.vue?vue&type=script&lang=js&"
export * from "./DemoTimePickerFormat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTimePicker } from 'vuetify/lib/components/VTimePicker';
installComponents(component, {VTimePicker})
